import type { ReactNode } from "react";

export function fmtDate(iso?: string | null): string {
  return iso ? new Date(iso).toLocaleString() : "—";
}

export function fmtNum(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString();
}

export function useFlash(setToast: (s: string | null) => void) {
  return (msg: string) => {
    setToast(msg);
    setTimeout(() => setToast(null), 3500);
  };
}

export function PageHeader({ title, sub, children }: { title: string; sub?: string; children?: ReactNode }) {
  return (
    <div className="page-header">
      <h1>{title}</h1>
      {sub && <p className="page-sub">{sub}</p>}
      {children}
    </div>
  );
}

export function Stat({ label, value, tone }: { label: string; value: ReactNode; tone?: "warn" | "bad" }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color: tone === "bad" ? "var(--danger)" : tone === "warn" ? "var(--warning)" : undefined }}>
        {value}
      </div>
    </div>
  );
}
